import Button from './Button.js';
export { default } from './Button.js';
//# sourceMappingURL=index.js.map
